import { h, Component } from 'preact';
import Checkboxes from './Checkboxes';
import Filters from '../components/Filters';
import OrderBy from '../components/Orderby';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class Filter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      isLoading: false,
    };
  }

  render() {
    const { filterActive } = this.props;
    const activeClass = filterActive ? 'active' : '';

    const resultsNumber = this.props.allPosts.length > 0 ? this.props.allPosts.length : this.props.posts.length;

    return (
      <div className={`c-shop-filter ${activeClass}`}>
        <div className="c-shop-filter__filter-wrapper">
          <div className="c-shop-filter__wrapper">
            <div className="c-shop-filter__top-bar u-hide-on-large-up">
              <div className="c-shop-filter__top-bar-title">Filteren</div>
              <svg className="c-icon c-shop-filter__filter-icon" onClick={this.props.handleToggle}>
                <use href="#close" xlinkHref="#close" />
              </svg>
            </div>

            <div class="c-shop-overview__count u-flex u-hide-on-medium-down">
              {resultsNumber} resultaten
            </div>

            <OrderBy
              order={this.props.order}
              onSelectOrder={this.props.handleOrder}
              postsLoading={this.props.loading}
              handleChange={this.props.handleChange}
              isLoading={this.props.isLoading}
            />

            <Checkboxes
              handleChange={this.props.handleChange}
              handleClick={this.props.handleClick}
              target="currentCategories"
              items={this.props.allCategories}
              currentElements={this.props.currentCategories}
              type="categories"
              title="Categorie"
              isLoading={this.props.isLoading}
              allPosts={this.props.allPosts}
            />
            <Checkboxes
              handleChange={this.props.handleChange}
              handleClick={this.props.handleClick}
              target="currentWidths"
              items={this.props.allWidths}
              currentElements={this.props.currentWidths}
              type="widths"
              title="Matdikte"
              isLoading={this.props.isLoading}
              allPosts={this.props.allPosts}
            />
            <Checkboxes
              handleChange={this.props.handleChange}
              handleClick={this.props.handleClick}
              target="currentColors"
              items={this.props.allColors}
              currentElements={this.props.currentColors}
              type="colors"
              title="Kleur"
              isLoading={this.props.isLoading}
              allPosts={this.props.allPosts}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/js/shop-overview/containers/Filter.js